import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../project';
import { DbRecordService } from '../db-record.service';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'app-project-db-records-stats',
  templateUrl: './project-db-records-stats.component.html',
  styleUrls: ['./project-db-records-stats.component.css']
})
export class ProjectDbRecordsStatsComponent implements OnInit {
  @Input() project: Project;

  constructor(
    private dbrs: DbRecordService,
    private utils: UtilsService
  ) { }

  ngOnInit() {
  }

  get total() {
    return this.dbrs.getTotalDbRecordsCount(this.project);
  }

  get unique() {
    return this.dbrs.getUniqueDbRecordsCount(this.project);
  }

  get sbucketURL() {
    return `https://console.cloud.google.com/storage/browser/ecomole-test.appspot.com/ChromeDrive/${this.project.shortcut}/`;
  }

  get fbucketURL() {
    return `https://console.cloud.google.com/storage/browser/ecomole-test.appspot.com/SearchManagerFiles/${this.project.shortcut}/`;
  }

  exportIDs() {
    const ls = [];
    this.dbrs.getProjectRecords(this.project).forEach((dbr, id) => {
      ls.push(id);
    });
    this.utils.saveExport(ls, 'recordIDs.json');
  }
}



// WEBPACK FOOTER //
// ./src/app/project-db-records-stats/project-db-records-stats.component.ts